import { render, staticRenderFns } from "./FormulaItem.vue?vue&type=template&id=7293c16e&scoped=true&"
import script from "./FormulaItem.vue?vue&type=script&lang=js&"
export * from "./FormulaItem.vue?vue&type=script&lang=js&"
import style0 from "./FormulaItem.vue?vue&type=style&index=0&id=7293c16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7293c16e",
  null
  
)

export default component.exports